import getStore from "../../store"
import { TUser } from "../@types/data/user"
import { clearOrderTokens } from "./orderToken"

/** Sai da conta neste aparelho: usuário, token, flag de login e tokens de pedido. */
export const clearSession = () => {
  getStore.getState().controllers.user.clear()
  try {
    sessionStorage.removeItem("user")
    localStorage.removeItem("token")
    localStorage.removeItem("logged")
  } catch {}
  clearOrderTokens()
}

/** Comprador do checkout sem login: não tem conta, só pedidos. */
export const isGuestSession = (user: Pick<TUser, "guest"> | null | undefined) =>
  user?.guest === true
